import { DataGridFeatureConfig } from '@waseel-asp/tpa-waseel-lib-staging';
import { GRID_PAGE_DEFAULT_SIZE } from "../../../../../../../shared/constants/grid-constant";

export const gridFeatures: DataGridFeatureConfig<IMorphology> = {
  isRowHoverEnable: true,
  showPagination: true,
  enableApiSorting: true,
  enableApiSearching: true,
  allowSorting: true,
  allowHideShowColumns: true,
  allowExpandRow: false,
  showCheckboxSelection: false,
  stickyFeature: {
      isStickyHeader: true,
  },
  allowSearching: true,
  paginatorFeatures: {
      defaultPagesize: GRID_PAGE_DEFAULT_SIZE,
      totalCount: 0,
      enableApiPagination: true
  }
};

  export interface IMorphology {
   morphologyId: string;
   code: string;
   variant: string;
   nameEnglish: string;
   nameArabic: string;
  }
  
  export const morphologyConfig = {
    entityName: 'CONFIGURATION.MORPHOLOGY.TITLE',
    nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
    nameArabic: 'FORM_FIELD.ARABIC_NAME',
    code : 'FORM_FIELD.CODE',
    variant: 'CONFIGURATION.MORPHOLOGY.VARIANT'
  };
  